import React, { useState } from "react";
import { CardHeader, Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import InputLabel from "@mui/material/InputLabel";
import { LoadingButton } from "@mui/lab";
import htmlToDraft from "html-to-draftjs";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";

const NewsHeadlines = (props) => {
  const {
    shopWebsiteConfig,
    handleChange,
    handleSave,
    handleRestore,
    loadingButton,
  } = props?.shopWebsiteCustomization;
  const data = shopWebsiteConfig?.NewsHeadlines;

  const [vchDescriptionEditor, setVchDescriptionEditor] = useState(() => {
    if (data?.vchDescription) {
      const contentBlock = htmlToDraft(data?.vchDescription);
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      return editorState;
    }
    return EditorState.createEmpty();
  });

  const handleDescriptionChange = (stateValue) => {
    setVchDescriptionEditor(stateValue);
    const val = draftToHtml(
      convertToRaw(vchDescriptionEditor.getCurrentContent())
    );
    handleChange("NewsHeadlines", "vchDescription", val);
  };

  return (
    <Card className="bg-white shadow-sm">
      <CardHeader
        title={
          <div className="text-[#24211F] text-base font-bold">
            News & Headlines
          </div>
        }
      ></CardHeader>
      <div style={{ border: "1px solid #ccc" }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputLabel
                className="text-base font-bold text-[#24211F]"
                htmlFor="headline"
              >
                Headline text
              </InputLabel>
              <TextField
                fullWidth
                variant="outlined"
                value={data?.vchHeadline}
                name="headline"
                id="headline"
                onChange={(e) =>
                  handleChange("NewsHeadlines", "vchHeadline", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel
                className="text-base font-bold text-[#24211F]"
                htmlFor="description"
              >
                Description
              </InputLabel>
              <Editor
                editorState={vchDescriptionEditor}
                onEditorStateChange={handleDescriptionChange}
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                toolbar={{
                  options: [
                    "inline",
                    "blockType",
                    "fontSize",
                    "textAlign",
                    "history",
                    "colorPicker",
                  ],
                  inline: {
                    options: ["italic", "bold", "underline"],
                    bold: { className: "demo-option-custom" },
                    italic: { className: "demo-option-custom" },
                    underline: { className: "demo-option-custom" },
                    strikethrough: { className: "demo-option-custom" },
                    monospace: { className: "demo-option-custom" },
                    superscript: { className: "demo-option-custom" },
                    subscript: { className: "demo-option-custom" },
                  },
                  blockType: {
                    className: "demo-option-custom-wide",
                    dropdownClassName: "demo-dropdown-custom",
                  },
                  fontSize: { className: "demo-option-custom-medium" },
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </div>
      <CardActions
        sx={{ backgroundColor: "#FFF8F8", borderTop: "1px solid #C12637",height:'50px' }}
      >
        <Grid container >
          <Grid item xs={6}>
            <Button
              className="text-[#24211F] font-semibold"
              onClick={() => handleRestore("NewsHeadlines")}
            >
              Restore
            </Button>
          </Grid>
          <Grid item xs={6} container justifyContent={{ xs: "right" }}>
            <LoadingButton
              variant="outlined"
              disabled={loadingButton === "NewsHeadlines" ? true : false}
              loading={loadingButton === "NewsHeadlines" ? true : false}
              onClick={() => handleSave("NewsHeadlines")}
              className="text-[#C12637] font-semibold bg-white border-[#C12637]"
            >
              Save
            </LoadingButton>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default NewsHeadlines;
